import products from "./products";
import listProductsSuscription from "./listProductsSuscription";
export default{
    PRODUCTS: products,
    LIST_PRODUCTS_SUSCRIPTION: listProductsSuscription
}